/**
 * Browser Supabase client for auth (login, signup, OAuth, magic link).
 * Uses NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY (or legacy anon key).
 */
import { createBrowserClient } from "@supabase/ssr";
import type { Database } from "@tippo/types";
import type { TippoSupabaseClient } from "@tippo/data";

export function createSupabaseBrowserClient(): TippoSupabaseClient {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const publishableKey =
    process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY ??
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
  if (!url || !publishableKey) {
    throw new Error(
      "NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY (or NEXT_PUBLIC_SUPABASE_ANON_KEY) are required"
    );
  }
  return createBrowserClient<Database>(url, publishableKey);
}
